export const authorize = ({user, order}) => {
    return [order.order.customer.user.username, order.order.specialist.user.username].includes(user.username);
}
